export default __webpack_public_path__ + "static/media/mn_tea_head_1.0bb30dac.png";